// Mock data for RO Dekho website

export const services = [
  {
    id: 1,
    title: "RO Installation",
    description: "Professional installation of RO water purifiers with warranty. Expert technicians ensure proper setup for optimal performance.",
    icon: "Droplets",
    price: "Starting from ₹500"
  },
  {
    id: 2,
    title: "RO Repair & Service",
    description: "Quick repair services for all brands. We fix leakage, low water flow, bad taste, and all RO issues.",
    icon: "Wrench",
    price: "Starting from ₹300"
  },
  {
    id: 3,
    title: "AMC Packages",
    description: "Annual Maintenance Contract with regular servicing, free filter cleaning, and priority support.",
    icon: "Shield",
    price: "Starting from ₹1,999/year"
  },
  {
    id: 4,
    title: "Filter Replacement",
    description: "Genuine filters for all RO brands. Sediment, carbon, RO membrane, and post-carbon filters available.",
    icon: "Filter",
    price: "Starting from ₹400"
  },
  {
    id: 5,
    title: "Water Testing",
    description: "Free water quality testing with TDS meter. Know your water quality before choosing the right purifier.",
    icon: "TestTube",
    price: "Free"
  },
  {
    id: 6,
    title: "Emergency Service",
    description: "24/7 emergency repair service available. Same-day service for urgent issues in Jaipur.",
    icon: "Clock",
    price: "Call for details"
  }
];

export const products = [
  {
    id: 1,
    name: "Kent Grand Plus",
    brand: "Kent",
    capacity: "8L",
    technology: "RO + UV + UF + TDS",
    price: "₹17,999",
    image: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=400&h=400&fit=crop",
    features: ["Zero Water Wastage", "Multiple Purification", "8L Storage"]
  },
  {
    id: 2,
    name: "Aquaguard Delight",
    brand: "Aquaguard",
    capacity: "7L",
    technology: "RO + UV + MTDS",
    price: "₹14,499",
    image: "https://images.unsplash.com/photo-1563207153-f403bf289096?w=400&h=400&fit=crop",
    features: ["Energy Saving", "Smart LED Indicators", "Compact Design"]
  },
  {
    id: 3,
    name: "Livpure Glo",
    brand: "Livpure",
    capacity: "7L",
    technology: "RO + UV + Mineralizer",
    price: "₹12,999",
    image: "https://images.unsplash.com/photo-1550167991-4879a6aa6b87?w=400&h=400&fit=crop",
    features: ["Taste Enhancer", "7 Stage Purification", "Wall Mounted"]
  },
  {
    id: 4,
    name: "Blue Star Aristo",
    brand: "Blue Star",
    capacity: "6L",
    technology: "RO + UV",
    price: "₹11,499",
    image: "https://images.unsplash.com/photo-1603531564509-f536e681e63a?w=400&h=400&fit=crop",
    features: ["Aqua Taste Booster", "Child Lock", "Copper Technology"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    location: "Malviya Nagar, Jaipur",
    rating: 5,
    text: "Excellent service! They repaired my RO within 2 hours. Very professional and affordable. Highly recommended!",
    date: "2 days ago"
  },
  {
    id: 2,
    name: "Priya Verma",
    location: "Vaishali Nagar, Jaipur",
    rating: 5,
    text: "Got my new Kent RO installed from RO Dekho. Great service and the technician explained everything clearly.",
    date: "1 week ago"
  },
  {
    id: 3,
    name: "Amit Singh",
    location: "Mansarovar, Jaipur",
    rating: 5,
    text: "Best AMC package in Jaipur! Regular maintenance and genuine spare parts. Very satisfied with their service.",
    date: "2 weeks ago"
  },
  {
    id: 4,
    name: "Sunita Gupta",
    location: "Jagatpura, Jaipur",
    rating: 5,
    text: "Quick response and honest pricing. Fixed the leakage issue in my RO perfectly. Will definitely call again!",
    date: "3 weeks ago"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Expert Technicians",
    description: "Certified and experienced professionals for all RO brands",
    icon: "UserCheck"
  },
  {
    id: 2,
    title: "Genuine Parts",
    description: "100% authentic spare parts and filters with warranty",
    icon: "BadgeCheck"
  },
  {
    id: 3,
    title: "Quick Service",
    description: "Same-day service available across Jaipur",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Affordable Pricing",
    description: "Transparent and competitive pricing with no hidden charges",
    icon: "IndianRupee"
  },
  {
    id: 5,
    title: "Warranty Support",
    description: "Service warranty on all repairs and installations",
    icon: "Award"
  },
  {
    id: 6,
    title: "24/7 Support",
    description: "Round-the-clock customer support and emergency service",
    icon: "Phone"
  }
];

export const serviceAreas = [
  "Malviya Nagar", "Vaishali Nagar", "Mansarovar", "Jagatpura",
  "Pratap Nagar", "Raja Park", "C-Scheme", "MI Road",
  "Tonk Road", "Ajmer Road", "Sanganer", "Jhotwara"
];

export const faqs = [
  {
    id: 1,
    question: "How often should I service my RO water purifier?",
    answer: "We recommend servicing your RO every 3-4 months for optimal performance. Regular servicing includes filter cleaning, membrane check, and sanitization."
  },
  {
    id: 2,
    question: "Do you provide service for all RO brands?",
    answer: "Yes, we service all major brands including Kent, Aquaguard, Livpure, Blue Star, Pureit, and more. Our technicians are trained for multi-brand support."
  },
  {
    id: 3,
    question: "What is included in the AMC package?",
    answer: "Our AMC includes 4 free services per year, filter cleaning, membrane check, sanitization, and priority support with discounted spare parts."
  },
  {
    id: 4,
    question: "How quickly can you respond to service requests?",
    answer: "We provide same-day service for most areas in Jaipur. Emergency services are available 24/7 with technician dispatch within 2-4 hours."
  },
  {
    id: 5,
    question: "Do you offer warranty on repairs?",
    answer: "Yes, all our repair services come with a 30-day service warranty. Spare parts have manufacturer warranty as applicable."
  }
];
